import { mobileModule } from '@/store/mobile/module'

const getMobilePath = () => {
    return mobileModule.state.mobileAppPath
}

const getPlatform = () => {
    return mobileModule.state.platform
}

const getProductIndex = () => {
    return mobileModule.state.productIndex
}

const getPriorScreenName = () => {
    return mobileModule.state.priorScreenName
}

const isInArrivedFromMobileState = () => {
    return mobileModule.state.hasArrivedFromMobile
}

export default {
    getPlatform,
    getProductIndex,
    getPriorScreenName,
    isInArrivedFromMobileState,
    getMobilePath,
}
